import { ExportRoute } from '/@/modules/export/routes/ExportRoute';

export const router = [
  {
    path: `/${ExportRoute.EXPORT.path}/:type/:id?`,
    name: 'export-viewer',
    component: () => import('/@/modules/export/pages/ExportViewerPage.vue')
  }
];
